import ParseHTML from "../../global/components/ParseHTML";
import { Typography } from "@mui/material";
import { useResolutionsContext } from "../hooks/useResolutionsContext";

//This component is responsible for displaying the instructions text for a resolution event.
export default function InstructionsText() {
    const { staticText } = useResolutionsContext();
    return (
        <Typography variant="body1" component="div">
            {ParseHTML(staticText?.InstructionsText ?? '')}
        </Typography>
    );
}